export default __webpack_public_path__ + "static/media/blurry_gradient_blue.17af7f5b.png";